import { Currency } from '@/core/currency/interfaces';

const NOK: Currency = {
    name: 'Norwegian Krone',
    demonym: 'Norwegian',
    majorSingle: 'Krone',
    majorPlural: 'Kroner',
    codeNumeric: '578',
    symbol: 'kr',
    symbolNative: 'kr',
    minorSingle: 'øre',
    minorPlural: 'øre',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'NOK',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default NOK;
